import store from '@/store'

export default {
  fetchUserInfo: err => {
    const status = err.response.status

    if (status === 401) {
      return store.dispatch('user/refresh')
        .then(res => { store.dispatch('user/fetchUserInfo') })
        .catch(err => {
          console.info('apiHandleErrors: stop refresh', err.response)
        })
    }
    if (status === 500) {

    }

    console.warn(err)
  },

  login: err => {
    const status = err.response.status
    if (status === 422) {
      return Promise.reject(err.response.data.error.message.errors)
    }
    if (status === 500) {
      return Promise.reject(new Error('Hubo un problema en el servidor.'))
    }
  },

  logout: err => {
    const status = err.response.status

    if (status === 401) {

    }

    if (status === 500) {

    }
  },

  refresh: err => {
    const status = err.response.status

    if (status === 422) {
      console.info('Failed login with refresh_token.')
      return Promise.reject(err)
      // return false
    }
  },

  fetchCategories: err => {
    if (err && err.message) {
      console.warn(err.message)
      return
    }

    const status = err.response && err.response.status

    if (status === 401) {

    }
  },

  fetchPubs: err => {
    if (err && err.message) {
      console.warn(err.message)
      return
    }

    const status = err.response && err.response.status

    if (status === 500) {

    }
  },

  fetchAds: err => {
    if (err && err.message) {
      console.warn(err.message)
      return
    }

    const status = err.response && err.response.status

    if (status === 500) {

    }
  },

  getLocation: err => {
    const status = err.response.status

    if (status === 401) {

    }
  },

  fetchSearchLocations: err => {
    // const status = err.response.status
    console.warn('fetchSearchLocations:', err.response.data)
  }
}



// WEBPACK FOOTER //
// ./src/apiHandleErrors.js